import { ulid } from "@/schemas/commonFields";
import { z } from "@/zod";

export const readEmailRecipient = z.object({
  id: ulid,
  email_type_id: ulid,
  email_type_code: z.string(),
  email_type_name: z.string(),
  email_type_description: z.string().nullable(),
  recipient_id: ulid,
  recipient_ref_number: z.number().nullable(),
  recipient_first_name: z.string(),
  recipient_last_name: z.string(),
  recipient_full_name: z.string(),
  recipient_role_id: ulid.nullable(),
  recipient_role_code: z.string().nullable(),
  recipient_role_name: z.string().nullable(),
  recipient_account_status: z.boolean(),
});

export const displayEmailRecipient = readEmailRecipient
  .omit({
    email_type_id: true,
    email_type_code: true,
    email_type_name: true,
    email_type_description: true,
    recipient_first_name: true,
    recipient_last_name: true,
    recipient_role_id: true,
    recipient_role_code: true,
  })
  .readonly();

export const readAvailableEmailRecipient = z.object({
  id: ulid,
  ref_number: z.number().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  full_name: z.string(),
  role_id: ulid.nullable(),
  role_code: z.string().nullable(),
  role_name: z.string().nullable(),
  status: z.boolean(),
});

export const displayAvailableEmailRecipient = readAvailableEmailRecipient
  .omit({
    first_name: true,
    last_name: true,
    role_id: true,
    role_code: true,
  })
  .readonly();
